import clsx from 'clsx'

import { Paper } from 'shared/ui/paper'
import { Skeleton, SkeletonTheme } from 'shared/ui/skeleton'

import { RealtyOptionCard } from './ui/realty-option-card'

import s from './styles.module.scss'
import { RealtySelectionItem } from './types'

const SkeletonItemsCount = 3

interface RealtySelectionSectionProps {
  title?: string
  isLoading?: boolean
  items: RealtySelectionItem[]
  onSelectOption?: (optionId: string) => void
}

export const RealtySelectionSection = ({
  items,
  title,
  isLoading = false,
  onSelectOption,
}: RealtySelectionSectionProps) => {
  if (!isLoading && Boolean(!items.length)) {
    return null
  }

  return (
    <Paper
      padding={[12, 0]}
      radius="16"
    >
      {title && <h2 className={clsx('semi-bold-16', s.title)}>{title}</h2>}

      <div className={s.scrollContainer}>
        {isLoading
          ? [...Array(SkeletonItemsCount)].map((_, index) => (
              <SkeletonTheme key={index}>
                <div className={s.skeletonCard}>
                  <Skeleton className={s.skeletonImage} />

                  <div className={s.skeletonContent}>
                    <Skeleton className={s.skeletonPrice} />
                    <Skeleton className={s.skeletonDivider} />
                    <Skeleton className={s.skeletonTitle} />
                    <Skeleton className={s.skeletonButton} />
                  </div>
                </div>
              </SkeletonTheme>
            ))
          : items.map((item) => (
              <RealtyOptionCard
                key={item.id}
                item={item}
                isSelected={item.isSelected}
                onSelect={
                  onSelectOption ? () => onSelectOption(item.id) : undefined
                }
              />
            ))}
      </div>
    </Paper>
  )
}
